import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { __decorate } from "tslib";
import { Component, Prop } from "vue-property-decorator";
import FormBase from "@/components/validatableForm/FormBase.vue";

var FormSelect = /*#__PURE__*/function (_FormBase) {
  _inherits(FormSelect, _FormBase);

  var _super = _createSuper(FormSelect);

  function FormSelect() {
    _classCallCheck(this, FormSelect);

    return _super.apply(this, arguments);
  }

  return FormSelect;
}(FormBase);

__decorate([Prop()], FormSelect.prototype, "placeholder", void 0);

__decorate([Prop({
  required: true
})], FormSelect.prototype, "options", void 0);

FormSelect = __decorate([Component({})], FormSelect);
export default FormSelect;